{
  "credits": {
    "ledger": {
      "signupGift": "هدية التسجيل",
      "topUp": "شحن {{amount}} {{coin}}",
      "storePurchase": "شراء {{amount}} {{coin}} من {{store}}",
      "giftCode": "رمز الهدية {{code}}",
      "prize": "جائزة عجلة الحظ",
      "gift": "رصيد هدية",
      "stores": {
        "bazaar": "كافه بازار"
      }
    }
  }
}
